package pl.decks.chartjs.radar

import org.w3c.dom.HTMLCanvasElement
import pl.decks.chartjs.external.Chart
import pl.decks.chartjs.mode.UpdateMode

@Suppress("unused")
class Radar(ctx: HTMLCanvasElement, config: RadarConfig) {
    private val chart = Chart(ctx, config.toChartJs())

    fun update() = chart.update()
    fun update(mode: UpdateMode) = chart.update(mode.jsValue)
    fun destroy() = chart.destroy()
    fun resize() = chart.resize()
    fun toBase64Image(): String = chart.toBase64Image()

    fun updateConfig(config: RadarConfig) {
        val jsConfig = config.toChartJs()
        chart.data = jsConfig.data
        chart.options = jsConfig.options
        chart.update()
    }
}
